import { NetworkError } from './NetworkError';
import { FetchErrorName } from './types';

export class ForbiddenError extends NetworkError {
  public name = FetchErrorName.ForbiddenError;
  public constructor(message: string, endpoint?: string, url?: string) {
    super(message, undefined, endpoint, url);
    Object.setPrototypeOf(this, ForbiddenError.prototype);
  }
}
